module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('router-view'), _vm._v(" "), _c('footer', {
    staticClass: "wrap",
    class: _vm.$style.footer
  }, [_c('p', [_vm._v("© " + _vm._s(_vm.getYear) + " Rick Blything unless otherwise stated.")]), _vm._v(" "), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Site by "), _c('a', {
    attrs: {
      "href": "https://afew.london"
    }
  }, [_vm._v("AFEW")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b262d57c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 120
// module chunks = 2